
<template>

  <div class="lotti-therapist-management-module">

    <div class="lotti-module-title">Logopädinnen</div>

    <el-button
        class="lotti-management-add-button"
        icon="el-icon-plus"
        type="success"
        @click="$router.push('create-therapist')"
        circle>
    </el-button>

    <el-table :data="tableData"
              class=""
              ref="therapistTable"
              height="200px"
              stripe
              :default-sort = "{prop: 'status', order: 'descending'}"
              :row-key="tableData.id"
              style="width: 100%">

      <!--only dynamic with colum-->
      <el-table-column
          prop="name"
          label="Name"
          sortable
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="pensum"
          label="Pensum"
          sortable
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ scope.row.pensum }}%
        </template>
      </el-table-column>

      <el-table-column
          prop="overtime"
          label="Überzeit"
          sortable
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          {{ scope.row.overtime }} min
        </template>
      </el-table-column>

      <el-table-column
          prop="amountAssignedChildren"
          label="# Kinder"
          sortable
          :sort-orders="allowedSorting">
      </el-table-column>

      <el-table-column
          prop="status"
          label="Status"
          width="103px"
          sortable
          :sort-orders="allowedSorting">
        <template slot-scope="scope">
          <el-button size="mini" :type="getTypeFromStatus(scope.row.status)" @click="toggleStatus($event, scope.row)">{{ scope.row.status }}</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-dialog
        title="Statusänderung"
        :visible.sync="dialog.show"
        center
        modal
        width="400px">
      <div style="text-align: center">Status von <b>{{ dialog.therapistName }}</b> wirklich auf <b>{{ dialog.newStatus }}</b> setzen?</div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialog.show = false">Abbrechen</el-button>
          <el-button type="primary" @click="submitToggleStatus(dialog.therapistId); dialog.show = false">OK</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import auth from '../../auth.js';
import Vue from '../../main';
import {VueInstance} from '../../main';
import notification from "../../Helpers/NotificationHelper";

export default {

  data() {
    return {
      auth: auth,

      allowedSorting: ['ascending', 'descending'],
      tableData: [
        /*{
          id: 1,
          name: "Sarah Braun",
          overtime: 234,
          pensum: 35.19,
          amountAssignedChildren: 3,
          status: 'accepted'
        }*/
      ],

      dialog: {
        show: false,
        therapistName: null,
        therapistId: null,
        newStatus: null,
      },
    }
  },

  methods: {

    getAllTherapists() {
      Vue.http.get(
          'api/v1/service/get-therapists',
      ).then(response => {
        this.tableData = response.data;
      }, response => {
        // this.showError(response.data.message);
      })
    },

    //show dialog for confirmation
    toggleStatus(event, row) {

      let per = 'permitted',
          ref = 'refused';

      if (row.status === per) {
        this.dialog.newStatus = ref
      } else if (row.status === ref) {
        this.dialog.newStatus = per
      }
      if (row.status === ref || row.status === per) {
        this.dialog.therapistId = row.id;
        this.dialog.therapistName = row.name;
        this.dialog.show = true;
      }
    },

    //send status change to server
    submitToggleStatus(therapistId) {

      Vue.http.post(
          'api/v1/therapist/toggle-status',
          {
            id: therapistId
          }
      ).then(response => {

        //show success msg
        notification.showSuccess(this, 'Status wurden erfolgreich geändert');

        //update the own data
        this.getAllTherapists()

        //emmit event for all listening components/modules to reload data
        VueInstance.$emit('updatedTherapists', {});

      }, response => {
        // this.showError(response.data.message);
      })
    },

    getTypeFromStatus(status) {

      switch (status) {
        case 'permitted':
          return "success"
        case 'refused':
          return "danger"
        case 'pending':
          return "primary"
      }
    }
  },

  beforeMount() {
    this.getAllTherapists();
  }
}

</script>